module.exports = __webpack_public_path__ + "static/media/747376.5e946c20.svg";